import { ConsultationReviewContainer } from "../containers/ConsultationReviewContainer";

export const ConsultationReviewPage = () => (
    <ConsultationReviewContainer/>
)